import { InjectionToken, Provider } from '@angular/core';

function setSession(): void {
  localStorage.setItem('user-custom-session', (Math.random() * 24).toString());
}

function removeSession(): void {
  localStorage.removeItem('user-custom-session');
}

export const SESSION_TOKEN = new InjectionToken<{
  remove: () => void;
  set: () => void;
}>('SESSION_TOKEN');

export const SESSION_PROVIDER: Provider = {
  deps: [],
  provide: SESSION_TOKEN,
  useFactory: () => ({
    remove: removeSession,
    set: setSession,
  }),
};
